import { render } from "./GeneralSuggestions.vue?vue&type=template&id=47c5feb1"
import script from "./GeneralSuggestions.vue?vue&type=script&lang=js"
export * from "./GeneralSuggestions.vue?vue&type=script&lang=js"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__